import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import {
  People as PeopleIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Groups as GroupsIcon,
} from '@mui/icons-material';

import { selectUserPermissions, selectUserRoles } from '@store/auth';

import ApplicationTemplate from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';
import UserList from './pages/users/UserList';
import RoleList from './pages/roles/RoleList';
import GroupList from './pages/groups/GroupList';

import { getFirstRoute } from '../../utils/utils';

import { ROLES } from '../../app/App.constants';
import {
  USER_LIST_ROUTE,
  ROLE_LIST_ROUTE,
  GROUP_LIST_ROUTE,
} from './user-management.breadcrumbs';

const tabs = [
  {
    title: 'Users',
    icon: <PeopleIcon />,
    path: USER_LIST_ROUTE,
    roles: [ROLES.ROLE_ADMIN, ROLES.ROLE_USER_VIEW, ROLES.ROLE_USER_EDIT],
  },
  {
    title: 'Roles',
    icon: <AdminPanelSettingsIcon />,
    path: ROLE_LIST_ROUTE,
    roles: [
      ROLES.ROLE_ADMIN,
      ROLES.ROLE_USER_ROLE_VIEW,
      ROLES.ROLE_USER_ROLE_EDIT,
    ],
  },
  {
    title: 'Groups',
    icon: <GroupsIcon />,
    path: GROUP_LIST_ROUTE,
    roles: [
      ROLES.ROLE_ADMIN,
      ROLES.ROLE_GROUP_VIEW,
      ROLES.ROLE_GROUP_EDIT,
    ],
  },
];

function UserManagement() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="/users"
          exact
          element={<UserList permissions={permissions} />}
        />
        <Route
          path="/roles"
          exact
          element={<RoleList permissions={permissions} />}
        />
        <Route
          path="/groups"
          exact
          element={<GroupList permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default UserManagement;
